import { AlertTriangle } from "lucide-react";
import type { ArtifactEditConflict } from "../api/useWorkshopArtifacts";

/**
 * Someone saved the document while this person was editing it. Their text is
 * still in the editor. Save mine makes it the version after theirs, so both
 * stay in the history. Load theirs puts the newer version in the editor and
 * sets this person's unsaved text aside, with a five second Undo that brings
 * it back (the lens does that part).
 */
export default function ArtifactConflictNotice({
  conflict,
  onLoadTheirs,
  onKeepMine,
  busy = false,
}: {
  conflict: ArtifactEditConflict;
  onLoadTheirs: () => void;
  onKeepMine: () => void;
  busy?: boolean;
}) {
  const next = conflict.currentVersion + 1;
  return (
    <section role="alert" className="ws-doc-conflict">
      <p className="ws-doc-conflict-line">
        <AlertTriangle className="ws-doc-conflict-mark" strokeWidth={1.9} aria-hidden />
        <span>
          {conflict.by ?? "Someone"} saved v{conflict.currentVersion} while you were editing. Your
          text is still here.
        </span>
      </p>
      <p className="ws-doc-conflict-sub">
        Save mine as v{next} keeps both in the history. Load theirs sets your unsaved text aside,
        with Undo.
      </p>
      <div className="ws-doc-conflict-actions">
        <button type="button" className="ws-doc-btn" disabled={busy} onClick={onLoadTheirs}>
          Load their version
        </button>
        <button
          type="button"
          className="ws-doc-btn ws-doc-btn--primary"
          disabled={busy}
          onClick={onKeepMine}
        >
          Save mine as v{next}
        </button>
      </div>
    </section>
  );
}
